///// <reference path="../../../node_modules/@types/typeahead.js/index.d.ts" />
declare var OktaSignIn: any;
import { WidgetOptions } from '@okta/okta-signin-widget/types/src/types/options';
import { Injectable, Output } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router, UrlSerializer, UrlTree } from '@angular/router';
import { config, firstValueFrom, last } from 'rxjs';
import { environment } from '../../environments/environment';
import { GetSettingsResponse } from '../models/GetSettingsResponse';
import { LoginService } from './login.service';
import { IdmUtilities } from '@platform-idm/sdk-javascript';
import { VirtualKeyboardService } from '../shared/VirtualKeyboardService';

@Injectable({
  providedIn: 'root'
})
export class LoginWidgetService {
  //public config: LoginWidget_Config;
  public loginServiceUrl: string;
  public defaultRedirecTo: string;
  public elementId: string;
  widget = null;
  idp: GetSettingsResponse;
  username: string;
  singleScreenMode: boolean = false;


  virtualKeyboard: VirtualKeyboardService;


  singeScreenMode: boolean
  prompt: "login" | undefined;
  constructor(private loginService: LoginService, private route: ActivatedRoute, private router: Router) {
    this.prompt = this.getQueryVariable("prompt");

    if (this.getQueryVariable("configId") || this.getQueryVariable("crmId") || this.getQueryVariable("login_hint"))
      this.singleScreenMode = true;

    var lastDomain = this.getQueryVariable("defaultDomain");
    if (lastDomain) {
      this.writeLastDomainCookie(lastDomain);
    }

    let ln = this.utility.readCookie(this.LastUserNameCookieName);
    if (ln && ln.indexOf(lastDomain) >= 0) {
      this.utility.writeCookie(this.LastUserNameCookieName, ln.replace(lastDomain, ''));

    }


  }
  public setVirtualKeyboard(keyboard: VirtualKeyboardService) {
    this.virtualKeyboard = keyboard;
  }

  currentUsername = "";

  settings: { [username: string]: GetSettingsResponse } = {};
  async getSettings(username: string): Promise<GetSettingsResponse> {
    let defaultDomain = this.utility.getQueryVariable("defaultDomain");
    if (username && username.indexOf("@") == -1 && defaultDomain)
      username += defaultDomain;

    if (!this.settings[username]) {

      let app = this.getQueryVariable("app");
      let configId = this.getQueryVariable("configId");
      let authPerCustomer = this.getQueryVariable("authPerCustomer");
      let crmId = this.getQueryVariable("crmId");

      let idp = await firstValueFrom(this.loginService.getSettings(app, username, +configId, authPerCustomer, crmId));
      this.settings[username] = idp;
    }

    return this.settings[username];

  }
  showLogin() {
    return new Promise((resolve, reject) => {
      //document.getElementById("userSelectionScreen").style.display = "none";
      if (this.singleScreenMode) {
        this.virtualKeyboard.supressHidding();
      }
      console.log("showing login");
      if (this.widget) {
        this.widget.off();
        this.widget.remove();
      }
      var config = this.getOktaConfig();
      this.widget = new OktaSignIn(config);


      //Add the username that was entered in the previous authenticated session to a list
      this.addLastUserNameToList();

      // When the authorization flow is complete there will be a redirect to Okta.
      // Okta's servers will process the information and then redirect back to your application's `redirectUri`
      // If successful, an authorization code will exist in the URL as the "code" query parameter
      // If unsuccesful, there will be an "error" query parameter in the URL
      if (this.widget.showSignInAndRedirect) { //vlatest
        this.widget.showSignInAndRedirect({
          // Assumes there is an empty element on the page with an id of 'osw-container'
          el: `#${this.elementId}`
        }).then((res) => {

        })
          .catch(function (error) {
            console.error(error);
            reject(error);
          });;

      }

      this.widget.on('error', (context, error) => {
        console.error(error);
        reject(error);
      });
      this.widget.on('pageRendered', async (data) => {
        console.log("page rendered.", data);

        if (data.page == 'forgot-password') {
          //this.oktaService.displayInvalidMessage = false;


          let username: HTMLInputElement = <HTMLInputElement>document.getElementById("account-recovery-username");
          username.value = this.currentUsername;
          //          username.disabled = true;
          username.focus();
          this.triggerUsernameUpdate();


          let idp = await this.getSettings(this.currentUsername);
          this.widget.authClient.options.issuer = idp.baseUrl;


          // Add the "Answer Security Questions" button if it doesn't already exist.
          if (!document.getElementById('answer-sq-button')) {
            //var usernameControl = <HTMLInputElement>document.getElementById("account-recovery-username");
            //usernameControl.value = this.getUsernameControl().value;
            document.querySelector('[data-se=o-form-fieldset-container]')
              .insertAdjacentHTML('beforeend',
                '<a  id="answer-sq-button" data-se="answer-sq-button" ' +
                'class="button button-primary button-wide link-button mt-3" >Answer Security Questions</a>');
          }

          if (document.getElementById('answer-sq-button')) {
            document.getElementById('answer-sq-button').addEventListener('click', () => {
              this.redirectToForgotPasswordSSO();
            });
          }


        }

        if (data.page == 'primary-auth') {
          let forgotPasswords = document.getElementsByClassName('js-forgot-password');
          if (forgotPasswords.length > 0) {
            forgotPasswords[0].addEventListener('click', (e) => {
              this.currentUsername = this.getUsernameControl().value.trim();

            });
          }
        }

      });
      this.widget.on('afterRender', (context) => {
        this.afterRenderCallback(<string>context.controller);

        var signout = document.querySelector("[data-se='signout-link']");
        if (signout) {
          signout.addEventListener("click", () => {
            //after OKTA calls /cancel api, reload the browser so the UI renders the one or two step screens.
            //relying on OKTA route change, we will need to rethink how we are rendering the one/two step screens
            //no time now.
              window.location.reload();
          });
        }


        if (context.controller == "forgot-password") {
          this.screenNumber = 1; //reset the screen number, so when clicking back from forgot password, it goes back to the first screen
        }

        if (context.controller == "primary-auth") {
          this.addNextButton();
          this.afterWidgetRender();

        }
      });
      this.widget.on('ready', (context) => {

        if (!this.utility.getQueryVariable("code_challenge")) {
          setTimeout(() => {
            this.displayErrorMessage("code_challenge was not supplied.");
          }, 0);
        }

        if (!this.utility.getQueryVariable("app")) {
          setTimeout(() => {
            this.displayErrorMessage("app was not supplied.");
          }, 0);
        }
        resolve(null);
      });
    });
  }
  Last_Auth_SettingsName = "mx1.auth_settings";
  LastUserNameCookieName = "ln";
  LastUserNamesStorageKey = "lns";
  LastUserNamesCookiesKey = "mx1.lns";


  private readonly maxNumberOfUsers = 20;
  private addLastUserNameToList() {
    if (this.utility.getQueryVariable("hideRememberMe") != "true") {
      var lastName = this.utility.readCookie(this.LastUserNameCookieName);
      if (lastName) {
        let lastNames = [];

        if (this.utility.getQueryVariable("rememberMoreThanOneUserStorage") == "cookies")
          lastNames = JSON.parse(this.utility.readCookie(this.LastUserNamesCookiesKey) || "[]");
        else
          lastNames = JSON.parse(localStorage.getItem(this.LastUserNamesStorageKey) || "[]");





        if (lastNames.indexOf(lastName) < 0) {

          lastNames.unshift(lastName);
          if (lastNames.length > this.maxNumberOfUsers) {
            lastNames.pop();
          }

          if (this.utility.getQueryVariable("rememberMoreThanOneUserStorage") == "cookies")
            this.utility.writeCookie(this.LastUserNamesCookiesKey, JSON.stringify(lastNames));
          else
            localStorage.setItem(this.LastUserNamesStorageKey, JSON.stringify(lastNames));
        };
      }
    };
  }

  autocomplete = null;
  autoCompleteVisibleLimit = 5;
  enableAutocomplete(lastNames: string[]) {
    if (this.utility.getQueryVariable("rememberMoreThanOneUser") != "true")
      return;
    let jq: any = $;

    if (this.autocomplete) {
      jq('#okta-signin-username').autocomplete('destroy');

    }

    //https://xdsoft.net/jqplugins/autocomplete/
    this.autocomplete = jq('#okta-signin-username').autocomplete({
      source: [lastNames],
      limit: this.maxNumberOfUsers,
      visibleLimit: 5,
      openOnFocus: false,
      valid: (value, query) => value.toLowerCase().indexOf(query.toLowerCase()) == 0,
      minLength: 1
    });
    setTimeout(() => {
      //okta is trioggering a validation when autocomplete is enable. so lets do this workaround 
      this.getUsernameControl().value = "na"
      this.triggerUsernameUpdate();
      this.getUsernameControl().value = ""
    });


  }

  /**
   * Callback executed after the widhget renders ny of the views
   * @param controller
   */
  public afterRenderCallback(controller: string) {

  }

  redirectToForgotPasswordSSO() {

    const userName = (<HTMLInputElement>document.querySelector('input[name=username]')).value;
    if (userName) {
      let navigationExtras: NavigationExtras = {
        queryParams: { 'userName': userName },
      };
      var url = `/secured/reset-password?userName=${userName}&sourceURL=${encodeURIComponent(window.location.href)}`
      var defaultDomain = this.utility.getQueryVariable("defaultDomain");
      if (defaultDomain)
        url += `&sourceDomain=${defaultDomain}`;

      //this.router.navigateByUrl(url);
      window.location.href = url;
    } else {
      this.displayErrorMessage("Enter Email or username");
    }
  }

  public render(elementId: string): Promise<void> {


    this.loginServiceUrl = environment.login_service_url;
    var redirectTo = this.route.snapshot.queryParams["redirectTo"];
    if (!redirectTo) {
      redirectTo = `${window.location.protocol}//${window.location.host}/secured`;
    }
    this.defaultRedirecTo = redirectTo;

    this.elementId = elementId;


    if (this.forceCheckOktaSession) {
      var data = this.getCookie(this.Last_Auth_SettingsName);
      try {
        if (data)
          var obj = JSON.parse(data);

        this.idp = { baseUrl: obj.baseUrl, clientId: obj.clientId, id: "", useFirstFederatedProvider: false, redirectTo: "", federationOptions: [] }


      } catch (e) {
        console.error(e);
      }
    }
    if (!this.idp) {
      //some default data so the widget can be rendered. Real data will be set on the login/password screen after the tenant is selected
      this.idp = {
        baseUrl: 'https://noserver.com',
        clientId: 'empty_clientId',
        useFirstFederatedProvider: false,
        federationOptions: [],
        redirectTo: this.getQueryVariable("redirectTo")
      }


    }

    return new Promise( (resolve, reject) => {



      var callback = async (e) => {
        if (document.readyState !== "complete")
          return;

        var error = this.getQueryVariable("error");
        var error_description = "";
        if (error) {
          error_description = this.getQueryVariable("error_description");


          this.showLogin().then(x => {
            this.displayExistentErrorMessageFromQueryString();
          });
          resolve();

        }
        else {
          if (this.getQueryVariable("skipSessionCheck") == "true") {
            let qs = new URLSearchParams(window.location.search);
            qs.delete("skipSessionCheck");
            history.pushState(null, "Login", window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + qs.toString());

            this.showLogin().then(() => {
            });
            resolve();
            return;
          }



          if (this.prompt == 'login') {

            const params = new URLSearchParams({
              app: this.getQueryVariable("app"),
              authPerCustomer: this.getQueryVariable("authPerCustomer"),
              configId: this.getQueryVariable("configId"),
              crmId: this.getQueryVariable("crmId"),
              redirectTo: ""
            });

            //try to perform a logout. some stuff may not be deleted when running across different root domains
            let logoutUrl = `${environment.login_service_url}/api/auth/logout?${params.toString()}`;
            
            //lets do a regular call bypassing angular, this needs to be as quick as possbile
            //fire and forget.
            //if doing an OKTA redirect no-cors will ignore the response
            fetch(logoutUrl, { credentials: 'include', mode: 'no-cors' });

            this.showLogin().then(() => {
            });
            resolve();
          }
          else {
            console.log("checking session...");
            this.checkGlobalSession().catch(e => {
              console.log("session not found");

              this.showLogin().then(() => {
              });
              resolve();

            });
          }

        }
      };

      //some times ios devices get here when the document loaded
      if (document.readyState === "complete") {
        callback(null);
        return;
      }


      window.addEventListener("load", (e) => {
        callback(e);
      });


    });



  }
  server_error = "";
  server_error_description = "";

  displayExistentErrorMessageFromQueryString() {
    var error = this.getQueryVariable("error") || this.server_error;
    if (!error)
      return;




    var error_description = "";
    error_description = this.getQueryVariable("error_description") || this.server_error_description;
    this.server_error_description = error_description;
    this.server_error = error;


    if (error != "login_required" && error != "first_time_login") {
      this.displayErrorMessage(error_description);
      console.log(error_description);
    }


    let params = new URLSearchParams(window.location.search);
    params.delete("error");
    params.delete("error_description");
    let url = `${window.location.origin}${window.location.pathname}?${params.toString()}`;
    history.pushState(null, "Login", url);

  }



  getUsernameControl(): HTMLInputElement {
    var username = <HTMLInputElement>document.getElementsByName("username")[0];
    return username;
  }

  getState() {
    this.utility.writeCookie("mx1.state", window.location.pathname + window.location.search, null, false);

    return ".";
  }

  getBooleanQueryVariable(name: string): boolean {
    return this.convertToBoolean(this.getQueryVariable(name))
  }


  convertToBoolean(val: string): boolean {
    if (val == undefined)
      return null;
    if (val == null)
      return null;
    if (val.trim() == "")
      return null;

    return val.toLowerCase() == "true"
  }

  getLoginPath(): string {

    return window.location.pathname;
  }


  getRedirectUrl() {
    let redirectTo = this.getQueryVariable("redirectTo");
    if (!redirectTo) {
      var returnSite = this.getQueryVariable("ReturnSite");
      var returnUrl = this.getQueryVariable("ReturnUrl");
      if (returnSite) {
        redirectTo = returnSite;
      }
      if (returnUrl) {
        redirectTo += returnUrl;
      }
    }

    if (!redirectTo)
      redirectTo = this.defaultRedirecTo;
    if (!redirectTo) {
      console.error("redirectTo variable not set.");
    }
    return redirectTo;
  }

  private dec2hex(dec: any) {
    return ("0" + dec.toString(16)).substr(-2);
  }
  generateCodeVerifier() {
    var array = new Uint32Array(56 / 2);
    window.crypto.getRandomValues(array);
    return Array.from(array, this.dec2hex).join("");
  }

  checkGlobalSession(): Promise<boolean> {
    let redirect = this.getRedirectUrl();
    let app = this.getQueryVariable("app");
    let configId = this.getQueryVariable("configId");
    let authPerCustomer = this.getQueryVariable("authPerCustomer");
    let crmId = this.getQueryVariable("crmId");

    return fetch(`${this.loginServiceUrl}/api/auth/session?app=${app}&configId=${configId}&authPerCustomer=${authPerCustomer}&crmId=${crmId}&code_challenge=${this.getQueryVariable("code_challenge")}&traceData=`, { credentials: 'include' }).then(async e => {
      if (e.status == 401) {
        this.idp = await this.getSettings(null);
        this.checkOktaSession();
        return true;
      }
      return e.json().then(async x => {
        var url = redirect;
        if (x.callAuthorize) {

          this.idp = await this.getSettings(null);
          this.checkOktaSession();

        } else if (x.exchange_code) {
          var parameterPrefix = "";
          //if (url.startsWith("http"))
          parameterPrefix = "?";
          //else
          //    parameterPrefix = "#";//mobile apps

          if (url.indexOf(parameterPrefix) != -1) {
            parameterPrefix = "&";
          }

          url += parameterPrefix + 'code=' + x.exchange_code;
          let tracingData = this.utility.getQueryVariable("tracingData");
          if (tracingData) {
            url += "&tracingData=" + tracingData;
          }
          window.location.href = url;

        }
        else {
          throw "not sure what to do";

        }
        return false;
      })

    });

  }
  utility = new IdmUtilities();
  navigateToIdp(providerId) {
    window.location.href = this.idp.authorizeUrl + '?client_id=' + this.idp.clientId + '&idp=' + providerId + `&nonce=${this.nonceGenerator()}&redirect_uri=` + this.loginServiceUrl + '/api/auth/code&response_type=code&state=' + encodeURIComponent(this.getState()) + '&scope=openid%20email%20profile%20offline_access';
  }


  forceCheckOktaSession = false;
  checkOktaSession() {
    let url = "";
    if (this.idp.clientId != "empty_clientId") {
      url = this.idp.authorizeUrl + '?client_id=' + this.idp.clientId + `&nonce=${this.nonceGenerator()}&prompt=none&redirect_uri=` + this.loginServiceUrl + `/api/auth/code&response_type=code&state=` + encodeURIComponent(this.getState()) + '&scope=openid%20email%20profile%20offline_access';
      window.location.href = url;
      return false;
    }
    //lets not check the okta session, incase the browser was closed and the okta session was not closed. They may have a token  but will expire in 15min max.
    let qs = new URLSearchParams();
    qs.set("app", this.getQueryVariable("app"));
    qs.set("configId", this.getQueryVariable("configId"));
    qs.set("hideRememberMe", this.getQueryVariable("hideRememberMe"));
    qs.set("blankUsername", this.getQueryVariable("blankUsername"));
    qs.set("rememberMoreThanOneUser", this.getQueryVariable("rememberMoreThanOneUser"));
    qs.set("showOnscreenKeyboard", this.getQueryVariable("showOnscreenKeyboard"));
    qs.set("referrer", this.getQueryVariable("referrer"));
    qs.set("crmId", this.getQueryVariable("crmId"));
    qs.set("login_hint", this.getQueryVariable("login_hint"));
    qs.set("authPerCustomer", this.getQueryVariable("authPerCustomer"));
    qs.set("code_challenge", this.getQueryVariable("code_challenge"));
    url = `${window.location.protocol}//${window.location.host}?redirectTo=${encodeURIComponent(this.getRedirectUrl())}&error=first_time_login&error_description=${encodeURIComponent('Can not find previous authentication settings')}&${qs.toString()}`;
    window.location.href = url;


    //this.showLogin().then(x => {
    //});

    return false;
  }
  nonceGenerator(length = 20) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }



  getPasswordContainerControl() {
    return (<HTMLDivElement>document.getElementsByClassName("o-form-fieldset-container")[0].children[1]);

  }
  getPasswordControl() {
    return (<HTMLInputElement>document.getElementById("okta-signin-password"));

  }
  getLoginButton() {
    return (<HTMLButtonElement>document.getElementById("okta-signin-submit"));

  }
  getNextButton() {
    return (<HTMLButtonElement>document.getElementById("nextButton"));

  }

  hidePassword() {
    this.getPasswordContainerControl().style.display = "none";
  }
  showPassword() {
    this.getPasswordContainerControl().style.display = "";
  }
  addConfigurationDropdown() {
    var container = document.getElementsByClassName("o-form-fieldset-container")[0];

    var selectContainer = document.createElement("div");
    selectContainer.id = "configurationsSelect";
    container.appendChild(selectContainer);

    var label = document.createElement("label")
    label.className = "okta-form-label o-form-label"
    label.innerText = "Configuarion";
    label.style.marginTop = "-20px";
    selectContainer.appendChild(label);

    var select = document.createElement("select");
    select.style.width = "100%";
    select.style.height = "40px";
    var option = document.createElement("option");
    option.innerText = "Configuraton 1";
    select.appendChild(option);

    option = document.createElement("option");
    option.innerText = "Configuraton 2";
    select.appendChild(option);

    selectContainer.appendChild(select);
  }

  hideSigninButton() {
    document.getElementById("okta-signin-submit").style.display = "none";

  }

  getRememberMeContainer(): HTMLDivElement {
    var rememberMes = document.getElementsByClassName("o-form-input-name-remember");
    if (rememberMes.length == 0)
      return null;


    return <HTMLDivElement>rememberMes[0];
  }
  hideRememberMe() {
    let rememberMe = this.getRememberMeContainer();
    if (!rememberMe)
      return;
    rememberMe.parentElement.parentElement.style.display = "none";
  }

  showRememberMe() {
    let rememberMe = this.getRememberMeContainer();
    if (!rememberMe)
      return;
    rememberMe.parentElement.parentElement.style.display = "";

  }

  showSigninButton() {
    document.getElementById("okta-signin-submit").style.display = "";
  }


  lastUserName = "";
  rememberMeChecked = false;
  handleBackClick() {
    let referrer = this.utility.getQueryVariable("referrer");
    let login_hint = this.utility.getQueryVariable("login_hint");
    if (referrer) {


      let params: URLSearchParams;
      let host = referrer;

      let index = referrer.indexOf("?");
      if (index >= 0) {
        host = referrer.substring(0, index);
        params = new URLSearchParams(referrer.substring(index));
      }
      else
        params = new URLSearchParams();

      if (params.has("mx1.username")) {
        params.delete("mx1.username");
      }
      if (login_hint)
        params.set("mx1.username", login_hint);

      if (this.utility.getQueryVariable("showOnscreenKeyboard") == "true") {
        var enabled = this.utility.readCookie("mx1.onScreenKeyboardEnabled");
        if (enabled != "") {
          params.set("mx1.vk", enabled);
        }
      }


      let url = params.toString();
      url = decodeURIComponent(url);

      window.location.href = host + "?" + url;
      return;
    }
    this.screenNumber = 1;
    this.configureMultiTenant();
    this.afterRenderCallback("page-1");
  }
  screenNumber = 1;



  getRememeberMeControl(): HTMLInputElement {
    let elements = document.getElementsByName("remember");
    if (elements.length > 0) {
      return (<HTMLInputElement>elements[0]);
    }

    return null;
  }
  private writeLastDomainCookie(username) {

    var atIndex = username.indexOf("@");
    if (atIndex >= 0) {
      var now = new Date();
      var time = now.getTime();
      var expireTime = time + 1000 * 60 * 60 * 30;
      now.setTime(expireTime);

      document.cookie = "mx1.lastDomain=" + username.substring(atIndex + 1) + ";expires=" + now.toUTCString();
    }
    else {
      document.cookie = "mx1.lastDomain=" + username;
    }


  }
  //emailRegEx =         /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
  emailRegEx = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");


  async handleNextButtonClicked(e: Event = null) {

    document.getElementById("uxSpinner").style.display = "";
    this.hideErrorMessage();
    var username = this.getUsernameControl().value.trim();
    if (!this.validateUsername()) {
      this.hideSpinner();
      return false;
    }
    let rememberMeControl = this.getRememeberMeControl();
    if (rememberMeControl != null) {
      this.rememberMeChecked = this.getRememeberMeControl().checked;
    }


    this.screenNumber = 2;

    if (username) {
      this.writeLastDomainCookie(username);
    }


    let redirecting = false;

    try {

      this.processing = true;
      this.idp = await this.getSettings(username);

      this.idp.redirectTo = this.getQueryVariable("redirectTo");
      if (!this.idp) {
        this.displayErrorMessage("Could not determine the configuration for the user. Please contact support.");
        this.hideSpinner();
        return false;
      }
      if (!this.idp.clientId) {
        this.displayErrorMessage("ClientId was not specified. Please contact support.");
        this.hideSpinner();
        return false;
      }
      if (this.forceCheckOktaSession) {
      }
      if (this.idp.useFirstFederatedProvider) {
        if (this.idp.federationOptions.length == 0) {
          console.error("No federfated provider found.")
        }
        this.navigateToIdp(this.idp.federationOptions[0].id);
        redirecting = true;
        this.hideSpinner();
        return false;
      }



      //var redirectTo = this.getRedirectUrl();
      //history.pushState(null, "Login", window.location.protocol + "//" + window.location.host + window.location.pathname + "?redirectTo=" + redirectTo + "&showTenantSelection=" + this.config.showTenantSelection + "&showFederatedButtons=" + this.config.showFederatedButtons + "&forceIdpValue=" + this.config.forceIdpValue + "&forceIdp=" + this.config.forceIdp + "&audience=" + this.crmId);



      var usernameControl = this.getUsernameControl();

      this.showLogin().then(() => {

        this.displayExistentErrorMessageFromQueryString();

        this.screenNumber = 2;
        this.showPassword();
        this.showSigninButton();
        this.showRememberMe();
        this.hideNextButton();

        this.getUsernameControl().value = usernameControl.value
        if (usernameControl.value != '') {
          this.triggerUsernameUpdate();
          setTimeout(() => {
            document.getElementById("okta-signin-password").focus();
          }, 100);
        }
        //document.getElementById("configurationsSelect").style.display = "";


        var container = document.getElementsByClassName("primary-auth-container");
        if (container.length > 0) {
          (<HTMLDivElement>container[0]).style.display = "";
        }
        //if (username)
        //  this.getUsernameControl().disabled = true;




      });
    } catch (e) {
      console.error(e);
      let message = e.message;
      if (e.status == 500)
        message = "There has ben an error. Please try again later or contact support.";

      this.displayErrorMessage(message);
    }
    finally {
      this.hideSpinner();

      if (!redirecting) {
        this.processing = false;
      }

    }


    return true;
  }

  private hideSpinner() {
    let spinner = document.getElementById("uxSpinner");
    if (spinner) {
      spinner.style.display = "none";
    }
  }
  private _processing = false;
  public get processing() {
    return this._processing;
  }
  public set processing(value) {
    this._processing = value;
    var nextButton = (<HTMLInputElement>document.getElementById("nextButton"));
    if (value) {
      nextButton.classList.add("disabled");
      //nextButton.innerText = "Processing ...";
    }
    else {
      nextButton?.classList.remove("disabled");
      //if (nextButton)
      //nextButton.innerText = "Next";
    }

    if (nextButton)
      nextButton.disabled = value;

  }

  addClearIcon() {
    let userControl = this.getUsernameControl();


    let clearIcon = document.createElement("i");
    clearIcon.classList.add("fa", "fa-xmark", "clear-icon");

    clearIcon.innerText = "";

    clearIcon.addEventListener("click", e => {
      if (userControl.disabled)
        return;

      userControl.value = "";
      this.triggerUsernameUpdate();

      userControl.focus();
    })


    userControl.parentElement.appendChild(clearIcon);

    //let iElement = <HTMLElement>document.createElement("i");
    //iElement.classList.add("fa")
    //iElement.classList.add("fa-xmark")
    //iElement.innerHTML = "&nbsp;";
    //userControl.parentNode.insertBefore(iElement, userControl.nextSibling);
  }
  addNextButton() {
    var previousElement = document.getElementById("nextButtonContainer");
    if (previousElement) {
      previousElement.remove();
    }
    var nextButtonContainer = document.createElement("div");
    nextButtonContainer.className = "o-form-button-bar";
    nextButtonContainer.id = "nextButtonContainer";
    nextButtonContainer.style.display = "none";

    var nextButton = document.createElement("button");
    nextButton.id = "nextButton";
    nextButton.innerText = "Next";
    nextButton.className = "button button-primary";
    nextButton.type = "button";
    nextButton.addEventListener("click", (e) => { return this.handleNextButtonClicked(e); });
    nextButtonContainer.appendChild(nextButton);
    document.getElementsByTagName("form")[0].appendChild(nextButtonContainer);

    var spinner = document.createElement("img");
    spinner.setAttribute("id", "uxSpinner");
    spinner.setAttribute("alt", "Spinner");
    spinner.setAttribute("width", "30px");
    spinner.setAttribute("src", "/assets/images/spinner.gif");
    spinner.setAttribute("style", "display:none; margin-left:10px; margin-top:-2px; position:absolute");

    nextButton.appendChild(spinner);





  }

  hideNextButton() {
    document.getElementById("nextButtonContainer").style.display = "none";
  }



  captureEnterKeyOnUsername() {
    var username = this.getUsernameControl();
    username.addEventListener("keypress", e => {
      if (e.key == "Enter") {
        if (this.processing)
          return false;

        e.preventDefault();
        this.handleNextButtonClicked();
        return false;
      }

      return undefined;
    });

  }

  triggerClick(control: HTMLInputElement) {
    if (document.all) {
      control.click();
    } else {
      var evObj = document.createEvent('MouseEvents');
      evObj.initMouseEvent('click', true, true, window, 1, 12, 345, 7, 220, false, false, true, false, 0, null);
      control.dispatchEvent(evObj);
    }
  }

  triggerUsernameUpdate() {
    var control = this.getUsernameControl();
    this.triggerKeysEvent(control);

  }

  triggerPasswordUpdate() {
    var control = this.getPasswordControl();
    this.triggerKeysEvent(control);
  }
  triggerKeysEvent(control: HTMLInputElement) {
    var keyboardEvent = document.createEvent('KeyboardEvent');
    var initMethod = typeof keyboardEvent.initKeyboardEvent !== 'undefined' ? 'initKeyboardEvent' : 'initKeyEvent';

    keyboardEvent[initMethod](
      'keydown', // event type: keydown, keyup, keypress
      true, // bubbles
      true, // cancelable
      window, // view: should be window
      false, // ctrlKey
      false, // altKey
      false, // shiftKey
      false, // metaKey
      40, // keyCode: unsigned long - the virtual key code, else 0
      0, // charCode: unsigned long - the Unicode character associated with the depressed key, else 0
    );
    control.dispatchEvent(keyboardEvent);

  }

  setCookie(name, value, rootDomain = false) {
    // path=/' + domainSuffix;
    var text = `${name}=${value}`;
    let domainSuffix = '';

    if (rootDomain) {
      let host = window.location.hostname;
      const index = host.indexOf('.');
      domainSuffix = '';
      if (index >= 0) {
        host = host.substr(index);
        domainSuffix = ';domain=' + host;
      }

      text += domainSuffix;

      var now = new Date();
      var time = now.getTime();
      var expireTime: any = time + 1000 * 36000;
      now.setTime(expireTime);
      const hours = 0;
      const min = 60;
      const seconds = 60;
      text += ";max-age=" + (this.seconds(12, 0, 0)); //hours*min*sec
    }
    document.cookie = text;
  }

  private seconds(hours: number, minutes: number, seconds: number) {
    let ret = seconds;

    if (minutes > 0)
      ret += 60 * minutes;

    if (hours > 0)
      ret += 60 * 60 * hours;

    return ret;
  }
  getCookie(name) {
    // Split cookie string and get all individual name=value pairs in an array
    var cookieArr = document.cookie.split(";");

    // Loop through the array elements
    for (var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split("=");

      /* Removing whitespace at the beginning of the cookie name
      and compare it with the given string */
      if (name == cookiePair[0].trim()) {
        // Decode the cookie value and return
        return decodeURIComponent(cookiePair[1]);
      }
    }

    // Return null if not found
    return null;
  }


  getUsernameDisability() {
    if (this.getQueryVariable("login_hint")) {
      return true;
    }

    if (this.singleScreenMode) {
      return false;
    }
    if (!this.singleScreenMode && this.screenNumber == 2) {
      return true;
    }

    return false;
  }
  changeUsernameDisability() {
    let usercontrol = this.getUsernameControl();
    if (!usercontrol)
      return;

    usercontrol.disabled = this.getUsernameDisability();

  }
  validateUsername() {
    if (!this.utility.getQueryVariable("defaultDomain") && !this.emailRegEx.test(this.getUsernameControl().value)) {
      this.displayErrorMessage("You must enter the full username ie john.doe@mycompany.com");
      return false;
    }

    return true;

  }
  configureMultiTenant() {

    //    $("form").on("submit", (e) => {
    //        e.preventDefault();
    //        nextButtonClicked();
    //        return false;
    //});
    this.getLoginButton().addEventListener("click", (e) => {

      //if (!this.singleScreen)
      {
        this.hideErrorMessage();
        if (!this.validateUsername()) {
          this.hideSpinner();
          e.preventDefault();
        }
      }

      //since username control ios manipularted, make sure it is validated
      this.triggerUsernameUpdate();
      this.changeUsernameDisability();

    });


    if (this.screenNumber == 1 || (this.screenNumber == 2 && this.singleScreenMode)) {
      if (!this.utility.getQueryVariable("hideRememberMe")) {
        let lastNames = [];

        if (this.utility.getQueryVariable("rememberMoreThanOneUserStorage") == "cookies")
          lastNames = JSON.parse(this.utility.readCookie(this.LastUserNamesCookiesKey) || "[]");
        else
          lastNames = JSON.parse(localStorage.getItem(this.LastUserNamesStorageKey) || "[]");


        if (lastNames.length >= 1) {
          this.enableAutocomplete(lastNames.sort());
        }
      }
      this.addClearIcon();
    }




    document.getElementById("nextButtonContainer").style.display = "";
    this.hidePassword();
    this.hideSigninButton();
    this.hideRememberMe();
    //document.getElementById("configurationsSelect").style.display = "none";

    var container = document.getElementsByClassName("primary-auth-container");
    if (container.length > 0) {
      (<HTMLDivElement>container[0]).style.display = "none";
    }
    this.hideErrorMessage();



    //the widget will enable the username automatically
    var observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation, e) => {
        if (mutation.attributeName == "disabled") {
          if (!mutation.target["disabled"]) { //okta updated to false
            mutation.target["disabled"] = this.getUsernameDisability();
          }
        }
      });
    });

    let usernameControl = this.getUsernameControl();

    observer.observe(usernameControl, {
      attributes: true //configure it to listen to attribute changes
    });
    this.changeUsernameDisability();


    var domain = this.getCookie("mx1.lastDomain");

    if (this.screenNumber == 1 && this.singleScreenMode) {
      let login_hint = this.getQueryVariable("login_hint");
      if (login_hint) {
        usernameControl.value = login_hint;
      }

      this.handleNextButtonClicked();
      return;
    }
    if (!this.utility.getQueryVariable("defaultDomain") && domain && !usernameControl.value) {
      usernameControl.value = "@" + domain;
    }
    if (this.lastUserName) {
      usernameControl.value = this.lastUserName;
    }
    let blankUsername = (this.utility.getQueryVariable("blankUsername") || "false") == "true";
    //in some scnarios we dont want to prepopulate the username. like in shared devices
    if (blankUsername) {
      usernameControl.value = "";
      usernameControl.setAttribute("autocomplete", "off");
      this.triggerUsernameUpdate();
    }

    if (usernameControl.value == "") {
      setTimeout(() => {
        usernameControl.focus();
      }, 150);
    }


    usernameControl.setSelectionRange(0, 0);
  }


  currentInputControl: HTMLInputElement;
  currentControlChanged: (control: HTMLInputElement) => void;


  afterWidgetRender() {
    //this.addConfigurationDropdown();
    this.captureEnterKeyOnUsername();

    this.getUsernameControl()?.addEventListener("focus", () => { this.currentInputControl = this.getUsernameControl(); if (this.currentControlChanged) this.currentControlChanged(this.currentInputControl); });
    this.getPasswordControl()?.addEventListener("focus", () => { this.currentInputControl = this.getPasswordControl(); if (this.currentControlChanged) this.currentControlChanged(this.currentInputControl); });


    //    if (this.config.showTenantSelection) {
    this.configureMultiTenant();
    //  }

    let rememberMeControl = this.getRememeberMeControl();
    if (rememberMeControl && this.rememberMeChecked) {
      if (!rememberMeControl.checked) {
        this.triggerClick(rememberMeControl);
      }
    }

  }

  getFederatedButtons() {
    //if (!this.config.showFederatedButtons)
    //  return [];

    return this.idp.federationOptions;
  }


  oktaConfig() {
    return this.idp;
  }


  logoUrl = '/assets/images/MatrixCare_Logo.svg';


  overrideOptions: Partial<WidgetOptions>;

  setWidgetOptions(options: Partial<WidgetOptions>) {
    this.overrideOptions = options;
  }

  getOktaConfig() {
    let customButtons = [];
    //if (!this.getQueryVariable("login_hint")) {
    if (!this.singleScreenMode || this.getQueryVariable("referrer")) {
      customButtons.push({
        title: "Back",
        className: "btn btn-primary",
        click: () => {
          this.handleBackClick();
        }
      });
    }
    //}

    var defaultDomain = this.utility.getQueryVariable("defaultDomain");
    var ret: WidgetOptions = {
      baseUrl: this.idp.baseUrl,
      clientId: this.idp.clientId,
      redirectUri: this.loginServiceUrl + '/api/auth/code',
      state: this.getState(),
      useClassicEngine: true,
      scopes: ['openid', 'email', 'profile', 'offline_access'],
      authParams: {
        pkce: false,
        responseType: 'code',
        issuer: this.idp.baseUrl,
        transactionManager: {
          enableSharedStorage: false
        }
      },
      idps: this.getFederatedButtons(),
      transformUsername: (username, operation) => {
        if (username.indexOf("@") == -1 && defaultDomain)
          username += defaultDomain;

        return username;

      },
      features: {
        rememberMe: this.getQueryVariable("hideRememberMe") != "true",
        showPasswordToggleOnSignInPage: IdmUtilities.isMobile()
      },
      logo: this.logoUrl,
      customButtons: customButtons,
      i18n: {
        en: {
          // Labels https://github.com/okta/okta-signin-widget/blob/master/packages/%40okta/i18n/src/properties/login.properties
          'primaryauth.title': 'Sign In with MatrixCare SSO',
          'primaryauth.username.placeholder': 'Username',
          'primaryauth.username.tooltip': 'Enter your Username',
          'primaryauth.password.placeholder': 'Password',
          'primaryauth.password.tooltip': 'Enter your password',
          // Errors
          'error.username.required': this.EnterUserNameMessage,
          "oform.errorbanner.title": this.ErrorsFoundMessage,
          'error.password.required': 'Please enter a password',
          'errors.E0000004': 'Sign in failed. Username or password entered is incorrect'
        },
      },
    };


    ret = Object.assign(ret, this.overrideOptions)
    return ret;
  }

  readonly EnterUserNameMessage = "Please enter a username";
  readonly ErrorsFoundMessage = "We found some errors. Please review the form and make corrections.";
  private hideErrorMessage() {
    const errorContainer = document.getElementsByClassName('o-form-error-container')[0];
    errorContainer.innerHTML = '';

  }


  private displayErrorMessage(message: string) {
    const errorContainer = document.getElementsByClassName('o-form-error-container')[0];
    errorContainer.className = 'o-form-error-container o-form-has-errors';
    const errorHtml = `<div>	    <div class="okta-form-infobox-error infobox infobox-error" role="alert">	      <span class="icon error-16"></span>	      	        <p>${message}</p>	      	    </div>	  </div>`;
    errorContainer.innerHTML = errorHtml;
  }

  getQueryVariable(variable): any {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair.slice(1).join("="));
      }
    }
    //console.info('Query variable %s not found', variable);
    return "";
  }

}


